export const DONATE_URL = 'https://payments.cashfree.com/forms/ht-donate-100';
